import React, { FunctionComponent, useEffect, useState } from 'react';
import { userAdminApi } from '../../../api/userAdminApi';
import { UserModel } from '../../../shared/types';
import UsersTable from './UsersTable/UsersTable';

const Users: FunctionComponent<any> = (props: any) => {
    const [users, setUsers] = useState([] as UserModel[]);
    const [isLoading, setIsLoading] = useState(true);

    const getUsers = async () => {
        const users: UserModel[] = await userAdminApi.getUsers();
        setUsers(users);
        setIsLoading(false)
    }

    useEffect(() => {
        getUsers();
    }, []);

    return (
        <UsersTable users={users} isLoading={isLoading}/>
    )

}

export default Users;